// TODO we should change this, see #1499
export const checkRequiredFields = <T extends Record<string, unknown>>(
  formData: T,
  requiredKeys: Array<keyof T>
): void => {
  for (const key of requiredKeys) {
    if (!formData[key]) {
      alert(`${key} is required`);
      throw new Error(`${key} is required`);
    }
  }
};
